<template>
  <div id="nb">
    <b-navbar toggleable="lg" type="dark" variant="info">
      <b-navbar-brand to="/">Brandiie Drive</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right>
            <template v-slot:button-content>
              <b-icon icon="box-seam"></b-icon> Packages
            </template>
            <b-dropdown-item to="/createpackage"
              >Create Package</b-dropdown-item
            >
            <b-dropdown-item href="/viewpackages"
              >View Packages</b-dropdown-item
            >
            <b-dropdown-item href="#" disabled>Manage Packages</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown right>
            <template v-slot:button-content>
              <b-icon icon="file-earmark-medical"></b-icon> Contracts
            </template>
            <b-dropdown-item href="/addcontract">Add Contract</b-dropdown-item>
            <b-dropdown-item href="/viewcontracts"
              >View Contracts</b-dropdown-item
            >
            <b-dropdown-item href="#" disabled
              >Manage Contracts</b-dropdown-item
            >
          </b-nav-item-dropdown>
          <b-nav-item-dropdown right>
            <template v-slot:button-content>
              <b-icon icon="building"></b-icon> Clients
            </template>
            <b-dropdown-item href="/addclient">Add Client</b-dropdown-item>
            <b-dropdown-item href="/viewclients">View Clients</b-dropdown-item>
            <b-dropdown-item href="#" disabled>Manage Clients</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template v-slot:button-content>
              <b-icon icon="person-circle"></b-icon> Profile
            </template>
            <b-dropdown-item href="#" disabled>View Profile</b-dropdown-item>
            <b-dropdown-item href="#" disabled>Change Password</b-dropdown-item>
            <b-dropdown-item href="/logout">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      staff: ""
    };
  },
  methods: {
    getStaff() {
      return this.staff;
    }
  }
};
</script>
<style scoped>
#nb {
  padding-bottom: 25px;
}
</style>
